module.exports = __webpack_public_path__ + "static/media/nf.6c057f27.svg";